module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0173.jpg?v=46f72199";